module.exports = __webpack_public_path__ + "img/nysl.05d52c0a.jpg";